import { Link } from "react-router-dom";
import { ArrowRight } from "react-bootstrap-icons";
import SectionHeading from "./SectionHeading";
import { getIcon } from "./icons";
import { OPTION_CARDS } from "./data/landingData";

const OptionCards = () => (
  <section className="lp-section" aria-labelledby="lp-options-title">
    <div className="container">
      <SectionHeading
        id="lp-options-title"
        eyebrow="What are you looking for?"
        title="Explore Your Property Options"
      />
      <div className="row g-4">
        {OPTION_CARDS.map(({ title, tag, icon, text, to, cta }) => {
          const Icon = getIcon(icon);
          return (
            <div key={title} className="col-12 col-md-6 col-lg-4">
              <article className="lp-card lp-card--lift h-100 p-4">
                <div className="d-flex justify-content-between align-items-start mb-4">
                  <span className="lp-icon-box"><Icon aria-hidden="true" /></span>
                  <span className="lp-badge">{tag}</span>
                </div>
                <h3 className="lp-card__title">{title}</h3>
                <p className="lp-muted">{text}</p>
                <Link to={to} className="lp-link">
                  {cta} <ArrowRight aria-hidden="true" />
                </Link>
              </article>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default OptionCards;
